function isDeprecatedOffering(offering) {
  return "action" in offering;
}
const EXISTING_CUSTOMER = "ExistingCustomer";
const NEW_PRESCRIPTION = "NewPrescription";
const PRESCRIPTION_FILE = "PrescriptionFile";
const EMAIL_PRESCRIPTION = "EmailPrescription";
function isExistingCustomer(prescription) {
  return (typeof prescription === "string" ? prescription : prescription?.type) === EXISTING_CUSTOMER;
}
function isNewPrescription(prescription) {
  return (typeof prescription === "string" ? prescription : prescription?.type) === NEW_PRESCRIPTION;
}
function isPrescriptionFile(prescription) {
  return (typeof prescription === "string" ? prescription : prescription?.type) === PRESCRIPTION_FILE;
}
function isEmailPrescription(prescription) {
  return (typeof prescription === "string" ? prescription : prescription?.type) === EMAIL_PRESCRIPTION;
}
function isPrescriptionType(prescription) {
  return [isExistingCustomer, isNewPrescription, isPrescriptionFile, isEmailPrescription].some(
    (typeCheck) => typeCheck(prescription)
  );
}
const isLenses = (type) => (typeof type === "string" ? type : type.productType) === "Contact-lenses";
const isFrames = (type) => (typeof type === "string" ? type : type.productType) === "Frames";
const isSunglasses = (type) => (typeof type === "string" ? type : type.productType) === "Sunglasses";
const isSolutions = (type) => (typeof type === "string" ? type : type.productType) === "Solutions";
const isReadyReaders = (type) => (typeof type === "string" ? type : type.productType) === "Ready-readers";
const isAccessories = (type) => (typeof type === "string" ? type : type.productType) === "Accessories";
const isAdditionalCartCosts = (type) => (typeof type === "string" ? type : type.productType) === "Additional-cart-costs";
const isProductTypeName = (productTypeName) => isLenses(productTypeName) || isFrames(productTypeName) || isSunglasses(productTypeName) || isSolutions(productTypeName) || isReadyReaders(productTypeName) || isAccessories(productTypeName);
const isProductWithAFrame = (type) => isSunglasses(type) || isFrames(type) || isReadyReaders(type);
export {
  isAccessories,
  isAdditionalCartCosts,
  isDeprecatedOffering,
  isEmailPrescription,
  isExistingCustomer,
  isFrames,
  isLenses,
  isNewPrescription,
  isPrescriptionFile,
  isPrescriptionType,
  isProductTypeName,
  isProductWithAFrame,
  isReadyReaders,
  isSolutions,
  isSunglasses
};
//# sourceMappingURL=commerce-tools-api.js.map
